import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { HelpHero } from '../components/HelpHero';
import { Breadcrumb } from '../components/Breadcrumb';
import { articles, categories } from '../data/articles';
export function ArticlePage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = articles.find(a => a.slug === slug);
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!article) {
    return <Navigate to="/" replace data-id="element-296" />;
  }
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-297">
      <HelpHero showSearch={true} data-id="element-298" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-id="element-299">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-300">
          {/* Left Sidebar - Navigation */}
          <aside className="w-full lg:w-1/4 flex-shrink-0" data-id="element-301">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-302">
              <h3 className="font-bold text-[#022a3b] mb-4 text-lg" data-id="element-303">
                Centro de Ayuda
              </h3>
              <nav className="space-y-1" data-id="element-304">
                {categories.map(category => <Link key={category.slug} to={`/${category.slug}`} className={`block py-2.5 px-3 rounded-md transition-colors ${article.categorySlug === category.slug ? 'bg-[#f0f9ff] text-[#0af] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#022a3b]'}`} data-id="element-305">
                    {category.name}
                  </Link>)}
              </nav>
            </div>
          </aside>

          {/* Right Content Area */}
          <article className="w-full lg:w-3/4 bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10" data-id="element-306">
            <Breadcrumb items={[{
            label: article.categoryName,
            href: `/${article.categorySlug}`
          }, {
            label: article.title
          }]} data-id="element-307" />

            <h1 className="text-3xl md:text-4xl font-bold text-[#022a3b] mb-8 leading-tight" data-id="element-308">
              {article.title}
            </h1>

            <div className="prose prose-blue max-w-none" data-id="element-309">{article.content}</div>

            {/* Helpful feedback section */}
            <div className="mt-16 pt-8 border-t border-gray-100 text-center" data-id="element-310">
              <p className="text-gray-600 font-medium mb-4" data-id="element-311">
                ¿Te resultó útil este artículo?
              </p>
              <div className="flex justify-center gap-4" data-id="element-312">
                <button className="px-6 py-2 border border-gray-200 rounded-md text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-colors" data-id="element-313">
                  Sí
                </button>
                <button className="px-6 py-2 border border-gray-200 rounded-md text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-colors" data-id="element-314">
                  No
                </button>
              </div>
            </div>
          </article>
        </div>
      </main>
    </div>;
}